export default __webpack_public_path__ + "c9c215b90a9e61b91fe8ae3b8ddb68e5.jpg";